import * as types from './actionTypes';
import campanhaApi from '../api/campanhaApi'


export function gravarSuccess(campanha) {
    
    return { type: types.GRAVAR_CAMPANHA, campanha }
}

export function gravar(campanha) {
    return function (dispatch) {
        return campanhaApi.gravar(campanha).then(resultado => {
            
            dispatch(gravarSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}


export function obterCampanhaPorTokenSuccess(campanha) {
    
    return { type: types.OBTER_CAMPANHA_POR_TOKEN, campanha }
}

export function obterCampanhaPorToken(campanha) {
    return function (dispatch) {
        return campanhaApi.obterCampanhaPorToken(campanha).then(resultado => {
            
            dispatch(obterCampanhaPorTokenSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}

export function obterCampanhaPorIdCampanhaSuccess(campanha) {
    
    return { type: types.OBTER_CAMPANHA_POR_IDCAMPANHA, campanha }
}

export function obterCampanhaPorIdCampanha(campanha) {
    return function (dispatch) {
        return campanhaApi.obterCampanhaPorIdCampanha(campanha).then(resultado => {
            
            dispatch(obterCampanhaPorIdCampanhaSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}


/** WEBPACK FOOTER **
 ** ./src/components/actions/campanhaActions.js
 **/